export default __webpack_public_path__ + "467e850.svg";